<mat-toolbar>

  <div class="left-side">
    <button mat-icon-button [matMenuTriggerFor]="mainMenu" aria-label="Main menu">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div class="center-area">
    <a href="/">
      <img
        alt=""
        id="main-logo"
        ngSrc="/assets/EIT_logo.png"
        priority
        height="274"
        width="911"
      />
    </a>
  </div>

  <div class="right-side">
    <button mat-icon-button matTooltip="{{'chooseLanguage' | translate}}" color="primary"
            [matMenuTriggerFor]="languageMenu">
      <mat-icon>language</mat-icon>
    </button>

    <mat-menu #languageMenu="matMenu">
      @for (language of translate.langs; track language) {
        <button mat-menu-item (click)="useLanguage(language)">
          <div class="row">
            <span>{{ language.toUpperCase() }}</span>
            @if (translate.currentLang === language) {
              <mat-icon color="primary">check</mat-icon>
            }
          </div>
        </button>
      }
    </mat-menu>

    <button mat-icon-button matTooltip="{{ username() }}" color="primary"
            [matMenuTriggerFor]="isAdmin() ? menu : null">
      <mat-icon>person</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item disabled>
        <span>{{ username() }}</span>
      </button>
      <button mat-menu-item routerLink="/admin">
        {{ 'adminPage.title' | translate }}
      </button>
    </mat-menu>

    <button mat-icon-button [color]="notificationsCount() > 0 ? 'warn' : 'primary'" [routerLink]="['/notifications']">
      <mat-icon
        [matBadge]="notificationsCount() > 0 ? notificationsCount() : null"
        matBadgeSize="small"
        [matBadgeColor]="notificationsCount() > 0 ? 'warn' : 'primary'">
        {{ notificationsCount() > 0 ? 'notifications_active' : 'notifications_none' }}
      </mat-icon>
    </button>

    <button mat-icon-button matTooltip="{{'logOut' | translate}}" color="primary" (click)="logOut()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>

</mat-toolbar>

<mat-menu #mainMenu="matMenu">
  <button mat-menu-item routerLink="/">
    <mat-icon>receipt</mat-icon>
    <span>{{ 'dashboard.orderTabLabel' | translate }}</span>
  </button>

  <button mat-menu-item routerLink="/invoices">
    <mat-icon>receipt_long</mat-icon>
    <span>{{ 'menu.unresolvedInvoices' | translate }}</span>
  </button>
</mat-menu>

@if (displayBanner && !envBannerCollapsed) {
  <div class="env-banner">
    <span></span>
    <span>{{ "header.banner" | translate }}</span>
    <button mat-icon-button (click)="toggleBanner()" class="small-icon-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
